import {DEAL_STATUSES, OFFER_CONFIRMATION_TYPES} from './constants';

function getOfferStatus(confirmationType: string) {
  return confirmationType === OFFER_CONFIRMATION_TYPES.manual
    ? DEAL_STATUSES.requested
    : DEAL_STATUSES.approved;
}

export {getOfferStatus};
